import { Box, Grid } from "@mui/material"
import PayoffLegends from "../payoffChart/payoffLegends"
import { PayoffLeg } from "../payoffContainer/livePayoffContainer"
import { memo, useMemo } from "react"
import PayoffGraphOrderTags from "./payoffGraphOrderTags/payoffGraphOrderTags"
import { useSelector } from "react-redux"
import { selectIsEmbedded } from "../../selectors/device"

export type PayoffGraphFooterProps = {
    payoffLegs: PayoffLeg[],
    readonly?: boolean
}

const PayoffGraphFooter: React.FC<PayoffGraphFooterProps> = ({payoffLegs, readonly}) => {
    const isEmbedded = useSelector(selectIsEmbedded)
    const style = useMemo(() => ({
        height: (payoffLegs.length > 0 && !isEmbedded) ? '70px' : '32px',
        width: '100%',
        position: 'relative',
        backgroundColor: theme => theme.palette.background.paper
    }), [payoffLegs, isEmbedded])
    return  <Box sx={style} >
                <Grid container item alignItems={'center'} justifyContent={'space-between'}
                    sx={{ px: '10px', boxSizing: 'border-box', py: 1, position: 'absolute', top: 0 }}>
                    <PayoffLegends />
                </Grid>
                <PayoffGraphOrderTags payoffLegs={payoffLegs} readonly={readonly} />
            </Box>
}

export default memo(PayoffGraphFooter);